module.exports = __webpack_public_path__ + "static/media/wolffox1.e92b4a1b.jpg";